// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"dd64883dce1157fa330f","655":"fa31dc0b64dd9d0d4601"}[chunkId] + ".js";
};